import { useScrollReveal, useCountUp } from '@/hooks/useScrollReveal';
import { stats } from '@/mocks/stats';

function StatCard({ stat, index }: { stat: typeof stats[0]; index: number }) {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>({ threshold: 0.3 });
  const count = useCountUp(stat.value, 2000, 0, isVisible);

  return (
    <div
      ref={ref}
      className={`flex flex-col items-center text-center p-5 md:p-6 rounded-2xl bg-white shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 group ${
        isVisible ? 'animate-fade-in-up' : 'opacity-0'
      }`}
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-brand-orange/10 text-brand-orange mb-3 group-hover:bg-brand-orange group-hover:text-white transition-colors duration-300">
        {stat.id === 1 && <i className="ri-shield-check-line text-xl" />}
        {stat.id === 2 && <i className="ri-user-star-line text-xl" />}
        {stat.id === 3 && <i className="ri-emotion-happy-line text-xl" />}
        {stat.id === 4 && <i className="ri-group-line text-xl" />}
        {stat.id === 5 && <i className="ri-building-line text-xl" />}
        {stat.id === 6 && <i className="ri-calendar-line text-xl" />}
      </div>
      <div className="text-3xl md:text-4xl font-extrabold text-charcoal-300 mb-1">
        {count}{stat.suffix}
      </div>
      <div className="text-xs md:text-sm text-charcoal-50 uppercase tracking-wider font-medium">
        {stat.label}
      </div>
    </div>
  );
}

export default function TrustSection() {
  const { ref: titleRef, isVisible: titleVisible } = useScrollReveal();

  return (
    <section className="w-full py-16 md:py-24 bg-ivory-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div
          ref={titleRef}
          className={`text-center mb-10 md:mb-14 ${titleVisible ? 'animate-fade-in-up' : 'opacity-0'}`}
        >
          <span className="inline-block text-xs md:text-sm font-semibold text-brand-orange uppercase tracking-widest mb-3">
            Our Track Record
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-charcoal-300">
            Numbers That Speak Trust
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4 max-w-6xl mx-auto">
          {stats.map((stat, i) => (
            <StatCard key={stat.id} stat={stat} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}